import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";
import profile from "./profile.vue";
let widget = class widget extends Vue {
    constructor() {
        super(...arguments);
        this.showAll = false;
    }
    get allSelected() {
        return (this.profileIds.length == this.selectedProfileIds.length);
    }
    allClick(e) {
        e.stopPropagation();
        if (this.allSelected)
            return this.setProfileIds([]);
        this.setProfileIds(this.profileIds);
    }
};
tslib_1.__decorate([
    Getter("auth/profiles")
], widget.prototype, "profiles", void 0);
tslib_1.__decorate([
    Getter("auth/profileIds")
], widget.prototype, "profileIds", void 0);
tslib_1.__decorate([
    Getter("config/profileIds")
], widget.prototype, "selectedProfileIds", void 0);
tslib_1.__decorate([
    Mutation("config/setProfileIds")
], widget.prototype, "setProfileIds", void 0);
widget = tslib_1.__decorate([
    Component({ components: { profile } })
], widget);
export default widget;
